import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'rxnt-loading-spinner',
  templateUrl: './rxnt-loading-spinner.component.html',
  styleUrl: './rxnt-loading-spinner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RxntLoadingSpinnerComponent {
  @Input() sizePx: number = 24;
  @Input() displayBlock: boolean = false; // inline by default
}
